import { Injectable } from '@angular/core';
import { PlatformService } from '@core/services/platform.service';
import { DestroyableComponent } from '@models/destroyable.component';

@Injectable({
  providedIn: 'root',
})
export class GameService extends DestroyableComponent {
  private _chatFrame: any;

  constructor(
    protected readonly platform: PlatformService,
  ) {
    super(platform);
  }

  public setGameFrame(frame: any) {
    this._chatFrame = frame;
  }

  public getGameFrame(): any {
    return this._chatFrame;
  }

  public clearGameFrame(): any {
    if (this._chatFrame) {
      this._chatFrame = null;
    }
  }
}
